import { Clear } from '@mui/icons-material';
import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
  TextField
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { typingTimeOut } from '../../../constants';
import { Manager } from '../../../models/manager';
import { managerService } from '../../../services/managerService';

export interface FilterManagersForm {
  managers?: Manager[];
  firstName?: string;
  lastName?: string;
  active?: string;
  email?: string;
}

interface Props {
  handleFormSubmit: (data: FilterManagersForm) => void;
  filterData: FilterManagersForm;
}

const defaultValues: FilterManagersForm = {
  managers: [],
  firstName: '',
  lastName: '',
  active: '',
  email: ''
};

const FilterManagers = (props: Props): JSX.Element => {
  const [filterData, setFilterData] = useState<FilterManagersForm>(
    props.filterData
  );
  const [managers, setManagers] = useState<Manager[]>([]);

  useEffect(() => {
    getManagers();
  }, []);

  const getManagers = () => {
    managerService.getManagerList().then((response) => {
      setManagers(response.data);
    });
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      props.handleFormSubmit(filterData);
    }, typingTimeOut);

    return () => clearTimeout(timeoutId);
  }, [filterData]);

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setFilterData((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value
    }));
  };

  const handleSelectChange = (
    event: SelectChangeEvent<string[]> | SelectChangeEvent
  ) => {
    const {
      target: { value, name }
    } = event;
    setFilterData((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const onClear = () => {
    setFilterData(defaultValues);
  };

  return (
    <form>
      <Grid container>
        <Grid item xs={11}>
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            <Autocomplete
              multiple
              id="manager"
              options={managers}
              getOptionLabel={(option) =>
                `${option.firstName} ${option.lastName}`
              }
              value={filterData.managers ?? []}
              onChange={(event, newValue) => {
                setFilterData((prevState) => ({
                  ...prevState,
                  managers: newValue
                }));
              }}
              filterSelectedOptions
              sx={{ width: '100%', maxWidth: 245 }}
              renderInput={(params) => (
                <TextField {...params} label="Manager" />
              )}
            />
            <TextField
              sx={{ maxWidth: 245 }}
              label="Email"
              name="email"
              value={filterData.email}
              onChange={handleChange}
            />
            <FormControl sx={{ width: '100%', maxWidth: 245 }}>
              <InputLabel id="active">Status</InputLabel>
              <Select
                label="status"
                name="active"
                value={filterData.active}
                onChange={handleSelectChange}
                input={<OutlinedInput label="status" />}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                <MenuItem value={'true'}>ACTIVE</MenuItem>
                <MenuItem value={'false'}>INACTIVE</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </Grid>
        <Grid item xs={1}>
          <Button
            variant="text"
            startIcon={<Clear />}
            onClick={() => onClear()}
          >
            Clear
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default FilterManagers;
